goog.provide('el8.apphome.reqAct.QueueTab');

goog.require('el8.apphome.reqAct.actions');
goog.require('el8.apphome.reqAct.fetchFn');
goog.require('el8.apphome.reqAct.QueueFeed');
goog.require('el8.appshared.letterFeedRenderer');
goog.require('el8.data.practiceUsers');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.render.homeReqActFeedItem');
goog.require('el8.template.render.reqAct');
goog.require('el8.util.localStorage');
goog.require('el8.util.perfMark');
goog.require('el8.appshared.react.renderNewMessageThread');


el8.apphome.reqAct.QueueTab = function(spec) {

    this._name = spec.name;
    this._urlName = spec.urlName || this._name;
    this._title = spec.title;
    this._emptyMsg = spec.emptyMsg || '';
    this._hasLaunchButtons = (spec.hasLaunchButtons !== false); // defaults to true
    this._addlFeedRenderFn = spec.addlFeedRenderFn || null;
    this._hasSortToggle = (spec.hasSortToggle !== false); // defaults to true)
    this._sortNewestFirst =
      el8.util.localStorage.getItem('practiceHomeSortNewestFirst') === 'true';
};

el8.apphome.reqAct.QueueTab.prototype.init = function(spec) {

    spec = spec || {};

    this._tabbedNav = spec.tabbedNav;
    this._isSectionHeader = spec.isSectionHeader;
    this._queueContainer = spec.queueContainer;
    this._feedUpdateCallbackFn = spec.feedUpdateCallbackFn || null;
    this._sortUpdatedFn = spec.sortUpdatedFn || null;

    this._queueContainer.append(
        el8.template.render.reqAct.tabContainer({name: this._name})
    );

    var that = this;
    var queueFeedName = 'req-act-' + this._name;

    this._feed = new el8.apphome.reqAct.QueueFeed({
        updateCallbackFn: function() {
            that._tabbedNav.updateTabCount(that._name);
            if (that._feedUpdateCallbackFn) { that._feedUpdateCallbackFn(); }
        },
        // Extra div wrapper req-act-section-feed prevents intereference between FeedRenderer.renderPage() and
        // TabbedNav.showTab()/hideTab() which would otherwise call show()/hide() on the same div.
        // FeedRenderer.renderPage() can be called from an async ajax code path, thus potentially causing the
        // wrong tab to be shown if TabbedNav had switched to a different tab during the async load.
        container: $('.req-act-section[data-name="'+this._name+'"] > .req-act-section-feed', this._queueContainer),
        tabName: this._name,
        urlName: this._urlName,
        name: queueFeedName,
        emptyMsg: this._emptyMsg,
        fetchFn: el8.apphome.reqAct.fetchFn,
        rendererFn: this._getRendererFn(),
        pageSize: 50,
        moreTrigger: '#req-act-'+this._name+'-more-btn',
        skeletonFn: function() {
            return el8.template.render.reqAct.feedSkeleton({
                name: that._name,
                hasLaunchButtons: that._hasLaunchButtons,
                hasSortToggle: that._hasSortToggle
            });
        },
        addlRenderFn: function() {
            that._updateLaunchXButtons();
            if (that._addlFeedRenderFn) { that._addlFeedRenderFn(that._queueType); }
        },
        addlRenderItemFn: function(renderedItem, item) {
            // Letters have collapsible sections even in req act
            var $letterItems = $('.letter-item, .letter-receipt-item, .unread-letter-notification-item', renderedItem);
            $letterItems.each(function(index, elem) {
                var $letterItem = $(elem);
                var id = $letterItem.attr('_id');
                var _item = item;

                // the 'item' that gets passed in is a reqActPatient
                if (el8.model.idToModelClass(id) === 'Letter') {
                    _item = el8.ptdata.letters.getById(id);
                } else if (el8.model.idToModelClass(id) === 'LetterReceipt') {
                    _item = el8.ptdata.letterReceipts.getById(id);
                } else if (el8.model.idToModelClass(id) === 'UnreadLetterNotification') {
                    _item = el8.ptdata.unreadLetterNotifications.getById(id).getLetter();
                }
                el8.appshared.letterFeedRenderer.render($letterItem, _item, true);
            });

            if (item.getModelClass() === 'ReqActPatient') {
                if (el8Globals.FEATURES.NewOfficeMessages) {
                    el8.appshared.react.renderNewMessageThread(renderedItem, {
                        feedName: queueFeedName,
                        messages: item.getMessageThreadMaps(),
                        itemId: item.getId(),
                        listStyle: {
                            // padding: 'var(--vds-space-sm) var(--vds-space-sm) var(--vds-space-sm) 90px',
                            paddingLeft: '90px'
                        },
                        onReplySuccess: function refresh(data, wasSignedOff) {
                            el8.ptdata.messageThreads.create(data);
                            that.getFeed().updatePatientAfterResponse(data.patient_id, wasSignedOff ? data.id : undefined)
                        },
                        showActionButtons: true,
                        showMessageIcon: true
                    });
                }
                
                var patientFormRequestReminders = item.getFormsRequestNotifications();
                if (patientFormRequestReminders.length) {
                    var reminderContainerId =  queueFeedName + '_' + item.getId() + '-messages';
                    el8React.render.patientFormRequestNotificationList(reminderContainerId, {
                        feedIndexItems: patientFormRequestReminders,
                    });
                }
            }
        },
        addlResetItemFn: function(item, renderedItem) {
            var $letterItems = $('.letter-item', renderedItem);
            $letterItems.each(function(index, elem) {
                var $letterItem = $(elem);
                el8.appshared.letterFeedRenderer.reset($letterItem, item);
            });
        },
        preProcessIndexFn: el8.apphome.reqAct.QueueTab.computeFeedIndex,
        urlIndex: el8.service.urls.get('reqActFeedIndex',
            [this._urlName, spec.queueType])
    });

    this._tabbedNav.addTab({
        title: this._title,
        name: this._name,
        isSectionHeader : this._isSectionHeader,
        contentDiv: $('.req-act-section[data-name="'+this._name+'"]', this._queueContainer),
        updateCountFn: function(name, $content, $count) {
            var count = that._feed.getIndexSize();
            if (count) {
                $count.addClass('el8TabItemCountHighlight');
            } else {
                $count.removeClass('el8TabItemCountHighlight');
            }
            return count;
        },
        showTabFn: el8.util.perfMark.instrument("Scenario:ReqActTab:" + that._name, 
            function() {
                that._feed.display();
            })
    });

    /* Need to init() so that the HTML gets appended */
    this._feed.init();

    // set the default sort order
    this.setSortOrder(this._sortNewestFirst);

    var sortTriggerSelector = "#req-act-sort-" + this._name + "-menu-trigger";
    var $sortTrigger = $(sortTriggerSelector);
    this._sortOrderMenu = new el8.uiwidget.NewActionsMenu({
        container: this._queueContainer,
        anchorTop: this._queueContainer,
        menuId: 'req-act-sort-' + this._name + '-menu',
        offsets: { top: 21, left: 0 },
        width: 105
    });

    $(document).on('click', sortTriggerSelector, function(e) {
        that._sortOrderMenu.display($sortTrigger,
                            null,
                            {top: 17, left: 10}, [
                            {
                                actionText : 'Newest First',
                                actionFn : function() {
                                    if (that._sortUpdatedFn) {
                                        that._sortUpdatedFn(true);
                                    }
                                }
                            },
                            {
                                actionText : 'Oldest First',
                                actionFn : function() {
                                    if (that._sortUpdatedFn) {
                                        that._sortUpdatedFn(false);
                                    }
                                }
                            }
                            ]);
    });

    this._feed.fetchDataIndex({
        async: true,
        newestFirst: this._sortNewestFirst,
        successCb: spec.callbackFn
    });

    return this;
};

el8.apphome.reqAct.QueueTab.prototype.toggleSortOrder = function() {
    this.setSortOrder(!this._sortNewestFirst);
};

el8.apphome.reqAct.QueueTab.prototype.setSortOrder = function(is_newest_first) {
    var $sortLabel = $("#req-act-sort-" + this._name + "-menu-trigger");

    if (is_newest_first) {
        $sortLabel.html('Newest First &#9662;');
    }
    else {
        $sortLabel.html('Oldest First &#9662;');
    }
    this._sortNewestFirst = is_newest_first;
};

el8.apphome.reqAct.QueueTab.prototype.refresh = function(opts) {

    opts = opts || {};

    if (opts.force) {
        this._feed.unfreeze();
        this._feed.refresh({
            async: opts.async,
            newestFirst: this._sortNewestFirst,
            successCb: opts.callbackFn
        });

    } else if (opts.isShowing) {
        this._feed.update({
            async: opts.async,
            newestFirst: this._sortNewestFirst,
            successCb: opts.callbackFn
        });

    } else {
        this._feed.fetchDataIndex({
            async: opts.async,
            newestFirst: this._sortNewestFirst,
            successCb: opts.callbackFn
        });
    }
};

el8.apphome.reqAct.QueueTab.prototype.updateQueueType = function(queueType, isShowing) {
    this._queueType = queueType;
    this._feed.updateIndexUrl(queueType);
    if (isShowing) {
        this._feed.refresh({
            newestFirst: this._sortNewestFirst
        });
    } else {
        this._feed.fetchDataIndex({
            newestFirst: this._sortNewestFirst
        });
    }
};

el8.apphome.reqAct.QueueTab.prototype.getFeed = function() {
    return this._feed;
};

el8.apphome.reqAct.QueueTab.prototype.updatePatientAfterResponse = function(patientId, idToRemove) {
    return this._feed.updatePatientAfterResponse(patientId, idToRemove);
};

el8.apphome.reqAct.QueueTab.prototype.isSelfQueue = function() {
    return this._feed ? this._feed.isSelfQueue() : false;
};

el8.apphome.reqAct.QueueTab.prototype._updateLaunchXButtons = function() {
    if (!this._hasLaunchButtons) { return; }
    var $elt = $('#req-act-'+this._name+'-launch-buttons');
    var count = this._feed.getIndexSize();
    $elt.html(
        el8.template.render.reqAct.launchXButtons({
            count: count,
            feedName: this._name
        })
    );
};

el8.apphome.reqAct.QueueTab.prototype._getRendererFn = function() {
    var feedName = this._name;
    var that = this;
    return function(_item) {
        var mClass = _item.getModelClass();

        
        if (mClass === 'ReqActPatient') {
            // If this patient is a VIP, the data necessary to render 'sub-items'
            // is not provided.  Since these methods eagerly build soy maps, provide
            // a different rendering function that doesn't call any of them.
            if (_item.isVip()) {
                return function(item, feedId) {
                    return el8.template.render.homeReqActFeedItem.reqActPatient({
                        feedId: feedId,
                        buttonsInfo: [], // none for now
                        patient: item.asSoyMap(),
                        feedName: feedName,
                        isSinglePhysicianPractice:
                            el8.data.practiceUsers.isSinglePhysicianPractice(),
                        isSelfQueue: that.isSelfQueue(),
                        messages: [],
                        reminderNotifications: [],
                        letters: [],
                        letterReceipts: [],
                        unreadLetterNotifications: [],
                        collaboratorNotifications: [],
                        directMessages: [],
                        reports: [],
                        useNewMessages: el8Globals.FEATURES.NewOfficeMessages
                    });
                };
            }
            else {
                return function(item, feedId) {
                    return el8.template.render.homeReqActFeedItem.reqActPatient({
                        feedId: feedId,
                        buttonsInfo: [], // none for now
                        patient: item.asSoyMap(),
                        feedName: feedName,
                        isSinglePhysicianPractice:
                            el8.data.practiceUsers.isSinglePhysicianPractice(),
                        isSelfQueue: that.isSelfQueue(),
                        messages: item.getMessageThreadMaps(),
                        reminderNotifications: item.getReminderNotificationMaps(),
                        letters: item.getLetterMaps(),
                        letterReceipts: item.getLetterReceiptMaps(),
                        unreadLetterNotifications: item.getUnreadLetterNotificationMaps(),
                        collaboratorNotifications: item.getCollaboratorNotificationMaps(),
                        directMessages: item.getDirectMessageMaps(),
                        reports: item.getReportMaps(),
                        useNewMessages: el8Globals.FEATURES.NewOfficeMessages
                    });
                };
            }
        } else if (mClass === 'RxRefillRequest') {
            return function(item, feedId) {
                var soyMap = item.getOriginalSpec();
                soyMap['received_time'] = el8.service.tz.soyStr(item.getReceivedTime());
                /* TODO I suspect this never gets used because we create a patient for rx refill requests we can't match */
                return el8.template.render.homeReqActFeedItem.rxRefillRequestNoPatient({
                    feedId: feedId,
                    buttonsInfo: el8.apphome.reqAct.actions.buttons(item),
                    item: soyMap,
                    feedItemId: item.getFeedItemId()
                });
            };
        } else if (mClass === 'IncomingEmail') {
            return function(item, feedId) {
                return el8.template.render.homeReqActFeedItem.unassignedEmail({
                    feedId: feedId,
                    buttonsInfo: el8.apphome.reqAct.actions.buttons(item),
                    item: item.asSoyMap(),
                    feedItemId: item.getFeedItemId()
                });
            };
        }
    };
};


/**
 * Convenient helper method for computing true feed index from data index
 * that comes from server
 */
el8.apphome.reqAct.QueueTab.computeFeedIndex = function(originalIndex) {

    var feedIndex = [];

    // NOTE: Assume dataIndex is ordered chronologically (earliest to latest),
    // and pre-sorted by patient_id
    // TODO Is sorted by patient_id a valid assumption?

    var currPatientId = null;
    var currPatientData = null;
    var currPatientFeedDate = null;

    var _flushCurrPatient = function() {
        feedIndex.push(
            {
                id: currPatientId,
                model_class: 'ReqActPatient',
                feed_date: currPatientFeedDate,
                data: currPatientData
            }
        );
        currPatientId = null;
        currPatientData = null;
        currPatientFeedDate = null;
    };

    for (var i=0; i<originalIndex.length; i++) {

        var dataItem = originalIndex[i];

        // Still looping through same patient
        if (currPatientId && (dataItem.patient_id === currPatientId)) {
            currPatientData.push(dataItem);
            var newDate = el8.service.tz.toTzDateTime(dataItem.feed_date);
            var currDate = el8.service.tz.toTzDateTime(currPatientFeedDate);
            if (newDate.getTime() < currDate.getTime()) {
                currPatientFeedDate = dataItem.feed_date;
            }

        } else  {

            // If there was a patient and we are moving on, add to feedIndex
            if (currPatientId) {
                _flushCurrPatient();
            }

            // If there's no patient associated, don't group by patient;
            // leave as standalone item
            if (!dataItem.patient_id) {
                feedIndex.push(dataItem);
                currPatientId = null;
                currPatientData = null;
                currPatientFeedDate = null;
            } else {
                // New patient
                currPatientId = dataItem.patient_id;
                currPatientData = [dataItem];
                currPatientFeedDate = dataItem.feed_date;
            }
        }
    }

    if (currPatientId) {
        _flushCurrPatient();
    }

    return feedIndex;
};
